import UserStoreModule from '../../../user/store/module';

export default function hasActivatedPOS(): boolean {
  return !!UserStoreModule.data?.store.has_pos;
}

export function hasActivatedFreemiumPOS(): boolean {
  return !!UserStoreModule.data?.store.has_freemium_pos;
}
